// api.js
import request from "@/utils/request";

export function login(params) {
  // 登录接口
  return request("/prod-api/login", {
    method: "post",
    data: params,
  });
}
export function getInfo(params) {
  // 获取用户信息
  return request("/prod-api/getInfo", {
    method: "get",
    data: params,
  });
}
export function memberGetInfo(params) {
  // 获取关联的长者档案
  return request("/prod-api/homeservice/member/list", {
    method: "get",
    data: params,
  });
}
export async function listBk(params) {
  // 查询长护险工单
  return await request("/prod-api/homeservice/orderLongcare/listBk", {
    method: "post",
    data: params,
  });
}
export async function contactList(params) {
  // 查询长护险工单
  return await request("/prod-api/homeservice/contact/list", {
    method: "get",
    data: params,
  });
}

export function serviceTypeSettingsList(params) {
  // 获取援助类别
  return request("/prod-api/homeservice/serviceTypeSettings/list", {
    method: "get",
    data: params,
  });
}
export function serviceCategorySettingsList(params) {
  // 获取服务分类
  return request("/prod-api/homeservice/serviceCategorySettings/list", {
    method: "get",
    data: params,
  });
}
export function serviceProjectSettingsList(params) {
  // 根据服务类型获取服务项目

  return request("/prod-api/homeservice/serviceProjectSettings/list", {
    method: "get",
    data: params,
  });
}

export function getServiceCountMonth(params) {
  // 获取长护险每月服务对象个数
  return request("/prod-api/homeservice/orderLongcare/getServiceCountMonth", {
    method: "get",
    data: params,
  });
}

export function getServicetjfx(params) {
  // 获取长护险工单服务统计数据（大屏服务对象分析）
  return request("/prod-api/homeservice/orderLongcare/getServicetjfx", {
    method: "get",
    data: params,
  });
}

export function postcount(params) {
  // 获取某岗位人数
  return request("/prod-api/system/user/postcount", {
    method: "get",
    data: params,
  });
}
export function getPostinfotjfx(params) {
  // 获取证书占比
  return request("/prod-api/system/post/getPostinfotjfx", {
    method: "get",
    data: params,
  });
}

export function postList(params) {
  // 获取岗位列表
  return request("/prod-api/system/post/list", {
    method: "get",
    data: params,
  });
}

export function postData(data) {
  return request.post("https://your-api-url/data", { json: data });
}
// ---------------------
// 获取护理团队数据
export function getNhTeamDataApi(params) {
  return request("/prod-api/openApi/hs/getNursingTeamStats", {
    method: "get",
    data: params,
  });
}
